<template>
        <keep-alive>
            <router-view/>
        </keep-alive>
</template>

<script>
    export default {
        name: "v_Player_Tickets"
    }
</script>

<style scoped>

</style>